<template>
    <div style="padding-top: 80px;background: #000;">

        <!--================ Video Area  =================-->
        <!-- <video id="bgVideo" preload="true" autoplay loop muted>
            <source src="https://player.vimeo.com/video/377946126" type='video/mp4'/>
            <source src="https://player.vimeo.com/video/377946126" type='video/webm'/>
        </video> -->
        <div style="padding:56.25% 0 0 0;position:relative;" v-if="initConfig.intro_vedio_viemo == 1">
          <iframe src="https://player.vimeo.com/video/402545088?autoplay=1&loop=1&title=0&byline=0&portrait=0&muted=1" loading="eager"  style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="muted; autoplay; fullscreen" allowfullscreen></iframe>
          <!-- <iframe src="https://player.vimeo.com/video/377946126?autoplay=1&loop=1&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="muted; autoplay; fullscreen" allowfullscreen></iframe> -->
        </div>
        <section class="video_area section_gap" style="background: #000;color: #ffff;">
            <div class="container">
                <div class="row">
                    <div class="col-md-7 d_flex align-items-center">
        Let’s arrange a Taitung Rich-Sunshine Inn tour, a fantastic point of mountain and sea (bay) view. Get chill and relax by walking under the coconut tree and soaking up in the sun.
        Nothing gonna stop us, If you're ready for a holiday.
                    </div>
                    <div class="col-md-5 d_flex align-items-center">
        「為自己安排一場不一樣的旅途吧！如果你已經準備好，讓我帶你環遊全新視野的山海景色，感受沐浴在陽光與椰林下的悠閒漫步時光。」 —富杉晴
                    </div>
                </div>
            </div>
        </section>
        <!--================ Video Area  =================-->
        <!--================Banner Area =================-->
        <section class="banner_area main_booking_area d-none">
            <div class="booking_table d_flex align-items-end">
            	<div class="overlay bg-parallax" data-stellar-ratio="0.9" data-stellar-vertical-offset="0" data-background=""></div>
              <div class="container">
                <div class="banner_content text-center">
                  <h6>Nothing gonna stop us, If you're ready for a holiday.</h6>
                  <h2>Relax, From Now On</h2>
                  <p>讓我們脫離城市的喧囂，<br/>在最剛好的高度寬闊旅行的視野，用最純粹的台東藍調色旅行的痕跡。</p>
                  <a hidden href="#" class="btn theme_btn button_hover">Get Started</a>
                </div>
              </div>
            </div>
            <div class="hotel_booking_area position" v-if="initConfig.booking_form == 1">
                <div class="container">
                    <div class="hotel_booking_table">
                        <div class="col-md-4 book_table_title">
                            <h2>Book<br> Your Room</h2>
                            <div class="book_now_btn book_now_btn_desktop button_hover"  @click="goBooking">Book Now</div>
                        </div>
                        <div class="col-md-8">
                            <div class="boking_table">
                                <div class="row">
                                    <HotelDatePicker :i18n="ptBr" @check-in-changed="getCheckinVal" @check-out-changed="getCheckoutVal" ></HotelDatePicker>
                                </div>    
                                <div class="book_table_item row">
                                    <div class="book_table_option">
                                      <label>大人</label>
                                      <select class="wide" v-model="book.adults">
                                          <option value="1">1</option>
                                          <option value="2">2</option>
                                          <option value="3">3</option>
                                          <option value="4">4</option>
                                          <option value="5">5</option>
                                          <option value="6">6</option>
                                      </select>
                                    </div>
                                    <div style="width: 20px;"></div>
                                    <div class="book_table_option">
                                      <label>小孩</label>
                                      <select class="wide" v-model="book.children">
                                          <option value="0">0</option>
                                          <option value="1">1</option>
                                          <option value="2">2</option>
                                      </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="book_now_btn book_now_btn_mobile  button_hover" @click="goBooking">Book Now</div>
                    </div>
                </div>
            </div>
        </section>

        
        <!--================Banner Area =================-->

        <section class="accomodation_area section_gap">
          <div class="container">
                <div class="row" id="buildADraw">
                    <div class="col-md-8">
                        <img style="max-width:100%;" src="../assets/mybuildinga2name.png" alt="building">
                    </div>
                    <div class="col-md-4" style="display:flex;align-items:center;">
                        <div style="background: rgba(0,0,0,.1);padding: 20px;border-radius: 5px;opacity: .6;">由大廳踏入室內走廊，一邊是面山客房，另一邊是面海客房，共有三層樓，各自擁有獨立的景觀陽台與設施。客房內以溫馨家庭風做為概念，利用淡雅的色調及質感木製家具帶來舒適放鬆的感受。</div>
                    </div>
                </div>
                <div class="row" id="buildBDraw">
                    <div class="col-md-8">
                        <img style="max-width:100%;" src="../assets/mybuildingb2name.png" alt="building">
                    </div>
                    <div class="col-md-4"  style="display:flex;align-items:center;">
                        <div style="background: rgba(0,0,0,.1);padding: 20px;border-radius: 5px;opacity: .6;">客房門口即是面海半戶外走廊，客房內陽台則是面花園或山景，共有三層樓。以輕工業風的元件設計與裝潢，讓喜歡略有設計空間的您，盡情享受無拘無束的自在感。</div>
                    </div>
                </div>
            </div>
        </section>

        <!--================Blog Categorie Area =================-->
        <section class="blog_categorie_area ">
            <div class="container">

                
        <div class="contact-way-area row justify-content-around">
          <div class="way-by-public contact-way-type col-md-10">
              <div class="way-name">入住退房時間</div>
              <div class="short-border"></div>
              <div class="way-detail">
                  <div>CHECKIN- 入住</div>
                  <h3>3:00pm – 9:00pm</h3> <br/>
              </div>
              <div class="way-detail">
                  <div>CHECKOUT- 退房</div>
                  <h3>8:00am – 11:00am</h3> <br/>
              </div>
          </div>
        </div>
                <div class="row">
                    <div class="col-lg-12 " style="margin-bottom:20px;" > 
                        <div class="categories_post">
                            <img src="../assets/news/bed-bedroom-bedsheet-2387753.jpg" alt="post">
                            <div class="categories_details color_reverse" @click="goPreknow()">
                                <div class="categories_text">
                                    <h5>訂房前須知&住宿約定</h5>
                                    <div class="border_line"></div>
                                    <p>想來度假嗎，相信您是個好旅人對吧</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-lg-6" >
                        <div class="categories_post">
                            <img src="../assets/news/photo-1574834892631-f773d4c7f3e7.jpg" alt="post">
                            <div class="categories_details" @click="goRegulation()">
                                <div class="categories_text">
                                    <h5>訂房流程&取消規定</h5>
                                    <div class="border_line"></div>
                                    <p>先了解訂房與取消規定，更快速的完成預訂</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6" >
                        <div class="categories_post">
                            <img src="../assets/news/photo-1574834892631-f773d4c7f3e7.jpg" alt="post">
                            <div class="categories_details" @click="goQA()">
                                <div class="categories_text">
                                    <h5>Q & A</h5>
                                    <div class="border_line"></div>
                                    <p>更多入住旅遊交通等相關疑問，先來這邊找答案</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--================Blog Categorie Area =================-->

        <section id="toBookEntry" ref="toBookEntry" class="float_book_area section_gap">
          <div class="button_button" @click="goBooking()" data-aos="zoom-out-up" data-aos-duration=2000>
              <div class="categories_text">
                  <img style="max-width:100%;" src="../assets/bookNowText.png" alt="book now" >
                  <p>即刻預訂｜到店付款</p>
                  <div class="border_line"></div>
                  <p style="font-weight: 600;">預訂即瞭解並同意「訂房前須知&住宿約定」</p>
              </div>
          </div>
        </section>



        <section class="murmur_area section_gap" style="background:#000;color: #ffff;">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 d_flex align-items-center">
                      民宿提供雙人、四人與六人房，並有多種房型與景致可以選擇<br/>您喜歡望山還是面海呢。<br/><br/>
                      客房整體空間雖然並不是特別大，但絕對不會感受到擁擠; 搭配簡單的裝潢，算是一種舒服的風格，更能襯托出戶外美麗的自然景色。<br/>
                      既然在台東，我們期待您 - 往外走，往外坐，往外看！<br/>
                      而我們提供您房間內貼心的五星沐浴用品以及完善的備品，結合戶外景致，更能好好的放鬆身心!<br/><br/>
                      當然，您的住宿費除了房間空間之外、也包含了這昂貴的山海灣圍繞景致
                    </div>
                </div>
            </div>
        </section>
        
        <!--================ Accomodation Area  =================-->
        <section class="accomodation_area section_gap">
            <div class="">
                <div class="section_title text-center">
                    <h2 class="title_color">Hotel Accomodation</h2>
                    <p>坐擁在大自然之間，寬敞舒適、採光充足的空間，<br/>讓每一位到訪於此的旅客都能享受房間內貼心的服務及放鬆自在的住宿體驗。</p>
                    <div class="button_hover theme_btn_two" style="margin-top: 20px;" @click="goAllRooms()">所有房型總覽</div>
                </div>
                <div class="rooms-gallery"> 
                    <div class="info">
                        <div class="drip-line"></div>
                        <div class="section-title">BASIC</div><div class="content">多元的基本房型，讓您自由選擇舒適的空間，享受與大自然結合的住宿時光。</div>
                    </div>
                    <carousel id="owl-demo1" :autoplay="true" :perPage="1" :perPageCustom="[[768, 1], [1024, 2]]" >
                        <slide v-for="(room) in roomDataListFilterSortedBasic" :key="room.room_name_eng" >
                            <div class="accomodation_item text-center" style="padding: 0 10px;" >
                                <div class="hotel_img">
                                    <img :src="pathheader + '//rich-sunshine.tw/sources/room/' + room.main_img.room_number + '/' + room.main_img.image + '.jpg'" alt="" style="height: 270px;width: 100%;object-fit: cover;">
                                    <div @click.stop="goRoomType(room.room_name_eng)" class="theme_btn button_hover">看一下</div>
                                </div>
                                <div @click.stop="goRoomType(room.room_name_eng)" ><h4 class="sec_h4">{{room.room_building}}棟 x {{room.room_name}}</h4></div>
                                <h5 class="d-none"><small>平日 </small>${{room.room_price * 0.5}}<small>起/晚 </small></h5>
                            </div>
                        </slide>
                    </carousel>
                </div>
                <div class="rooms-gallery -reverse -light"> 
                    <div class="info">
                        <div class="drip-line"></div>
                        <div class="section-title">UNIQUE</div><div class="content">獨一無二的設計房型，讓您坐擁最舒服及寬敞的大空間，盡情享受與大自然結合的住宿漫旅。</div>
                    </div>
                    <carousel id="owl-demo2" class="swiper" :autoplay="true" :perPage="1" :perPageCustom="[[768, 1], [1024, 1]]" >
                        <slide v-for="(room) in roomDataListFilterSortedSpec" :key="room.room_name_eng" >
                            <div class="accomodation_item text-center" style="padding: 0 10px;" >
                                <div class="hotel_img">
                                    <img :src="pathheader + '//rich-sunshine.tw/sources/room/' + room.main_img.room_number + '/' + room.main_img.image + '.jpg'" alt="" style="height: 270px;width: 100%;object-fit: cover;">
                                    <div @click.stop="goRoomType(room.room_name_eng)" class="theme_btn button_hover">瞧一瞧</div>
                                </div>
                                <div @click.stop="goRoomType(room.room_name_eng)"><h4 class="sec_h4">{{room.room_building}}棟 x {{room.room_name}}</h4></div>
                                <h5 class="d-none"><small>平日 </small>${{room.room_price * 0.5}}<small>起/晚 </small></h5>
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>
        </section>
        <!--================ Accomodation Area  =================-->
        <section class="accomodation_area  section_gap">
            <div class="section_title text-center">
                <h2 class="title_color">Amenities</h2>
                <p>以貼心的設施與服務，提供外出放鬆的您便利舒服的環境，享受台東獨特的美麗景緻。<br/>大廳設有小小商品展售區，嚴選人氣伴手禮、零食、紅酒與台東職人商品代售，交誼大廳並設有全自動義式咖啡機與飲水機。<br/>無論是休憩的空間或是旅遊活動的安排，在此都能無憂無慮的盡情享受台東獨有的度假氛圍。</p>
            </div>
            <IndexService></IndexService>
        </section>

        <section class="murmur_area section_gap" style="background: #000;color: #ffff;">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 d_flex align-items-center">
                      民宿位於台11線東部海岸線的小山坡上，沿者小山路車程約2分鐘的距離。<br/>我們並不緊鄰海邊，但因座落於山林間，更能同時欣賞到山海灣圍繞的優雅景致。<br/>交錯於綿延山脈、隔著搖曳椰樹，我們的海景更顯寧靜從容的樣貌，希望您也喜歡這樣的獨特視野！
                    </div>
                </div>
            </div>
        </section>

        
        <!--================ About History Area  =================-->
        <!--
        <section class="about_history_area section_gap">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                      <img class="img-fluid" src="../assets/news/my-pet.png" alt="img">
                    </div>
                    <div class="col-md-6 d_flex align-items-center">
                        <div class="about_content ">
                            <h2 class="title title_color"><small>與毛小孩一起<br>住一晚<br>Stay Overnight with Furkid</small></h2>
                            <p>/ 友善寵物入住 / <br/><br/>
                            提供3間寵物友善入住房型(皆為不提供加床房型):<br/>
                              1F 精緻雙人房: 一間<br/>
                              1F 精緻四人房: 兩間<br/><br/>
                            寵物房請直接與我們電話或LINE預訂，不接受由官網線上訂房及Agoda, Booking.com等OTA訂房平台預訂寵物入住，並請您務必先進入閱讀入住須知。
                            </p>
                            <div class="button_hover theme_btn_two" @click="goPetDetail()">喵 喵 喵 汪</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        -->
        <!--================ About History Area  =================-->
        <!--================ About History Area  =================-->
        <!--
        <section class="about_history_area section_gap">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 d_flex align-items-center">
                        <div class="about_content ">
                            <h2 class="title title_color"><small>Let's BBQ <br>烤肉方案</small></h2>
                            <p>
                              / 房客限定 x 預約制 /<br/><br/>
                              提供多種付費烤肉方案，讓入住的房客們也能夠在民宿享用一頓放鬆且樂趣的烤肉活動。
                            </p>
                            <div class="button_hover theme_btn_two"  @click="goBBQDetail()">來聞一下烤肉香</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img class="img-fluid" src="../assets/news/my-bbq.png" alt="img">
                    </div>
                </div>
            </div>
        </section>
        -->
        <!--================ About History Area  =================-->

        <!--================ About History Area  =================-->
        <!--
        <section class="about_history_area section_gap">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 d_flex align-items-center">
                        <div class="about_content ">
                            <h2 class="title title_color"><small>獨樂樂不如眾樂樂 <br>包棟享受</small></h2>
                            <p>
                              / 包棟優惠方案 /<br/><br/>
                              富杉晴民宿有兩棟建築，可分開提供包棟與包棟優惠價。<br/><br/>
A棟: 可容納 42人; 雙人房4間/ 四人房7間/ 六人房1間<br/>
B棟: 可容納 38人; 雙人房3間/ 四人房5間/ 六人房2間<br/><br/>
如果有包棟的需求或了解包棟價位，請直接與我們電話或LINE與我們聯絡詢問訂房唷!<br/>
若該棟已有房型被預訂，恕無法提供包棟服務，請及早預訂。
                            </p>
                            <div class="button_hover theme_btn_two"  @click="goSoleDetail()">那就包棟吧</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img class="img-fluid" src="../assets/news/whole3.jpg" alt="img">
                    </div>
                </div>
            </div>
        </section>
        -->
        <!--================ About History Area  =================-->
        
        <!--================ Latest Blog Area  =================-->
        <section class="testimonial_area  section_gap">
            <div class="container">
                <div class="section_title text-center">
                    <h2 class="title_color">Promotions & Activities</h2>
                    <p></p>
                </div>
                <div class="row mb_30">
                    <div class="col-lg-4 col-md-6 col-12" v-for="(news, index) in newsData" :key="index" >
                        <div class="single-recent-blog-post">
                            <div class="thumb">
                                <img v-if="news.main_img" class="img-fluid" :src="news.main_img" alt="post">
                                <img v-else src="../assets/news/default-news-banner.jpg" alt="富杉晴最新消息">
                            </div>
                            <div class="details" :style="{'background': bglist[index]}">
                                <div class="tags">
                                    <span class="tag_btn">{{news.type_name}}</span>
                                </div>
                                <h4 class="sec_h4 cursor_btn" @click.stop="goNewsDetailPage(news.news_id)">{{ news.title }}</h4>
                                <p>{{ news.brief }}</p>
                                <h6 class="date title_color">{{ news.publish_time }}</h6>
                            </div>	
                        </div>
                    </div>
                    <div class="col-12 align-items-center">
                    <div class="button_hover theme_btn_two"  @click="goNews()">消息一把抓</div>
                    </div>
                </div>
            </div>
        </section>
        <!--================ Latest Blog Area  =================-->
        


        <!--================ About History Area  =================-->
        <section class="about_history_area section_gap">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 d_flex align-items-center">
                        <div class="about_content ">
                            <h2 class="title title_color">About Us <br><small>  + travel with</small></h2>
                            <p>位於台東最美麗海岸線-台11縣的山林間，擁有絕佳的地理位置與便利的旅遊網絡，距離台東市區只需15分鐘，附近即有富山護魚區、加路蘭遊憩區、水往上流及都蘭新東糖廠等景點。距離台東火車站僅需25分鐘車程。擁有面向東部兩個海灣-都蘭灣與杉原灣的遼闊海景、並且坐擁壯闊山脈的舒活海景民宿。</p>
                            <div @click="goContactPage" class="button_hover theme_btn_two">交通方式</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3676.9411340125184!2d121.18292331426615!3d22.841667285045006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2a60322a4e284e40!2z5Y-w5p2x5a-M5p2J5pm05rCR5a6_IFJJQ0ggU1VOU0hJTkUgSU5O!5e0!3m2!1szh-TW!2sus!4v1540634760725" width="100%" height="500" frameborder="0" style="border:0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </section>
        <!--================ About History Area  =================-->
        
        <section class="about_history_area section_gap" v-show="initConfig.ig_wall == 1">
          <div class="ig-list">
            <div class="ig-item"  v-for="(igd, index) in IGPopularData" :key="index" >
              <a :href="getIGlink(igd.shortcode)" target="_blank" title="Click to IG"><img :src="igd.thumbnail_src" /><div class="shadow">{{ shortText(igd.edge_media_to_caption.edges) }}<span>{{ captureText(igd.accessibility_caption) }}</span></div></a>
            </div>
          </div>
        </section>
        <section class="about_history_area section_gap" v-show="initConfig.guest_wall == 1">
          <div class="ig-list">
            <div class="ig-item"  v-for="(igd, index) in IGPopularData" :key="index" >
              <a :href="getIGlink(igd.shortcode)" target="_blank" title="Click to IG"><img :src="igd.thumbnail_src" /><div class="shadow">{{ shortText(igd.edge_media_to_caption.edges) }}<span>{{ captureText(igd.accessibility_caption) }}</span></div></a>
            </div>
          </div>
        </section>

    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import HotelDatePicker from 'vue-hotel-datepicker'
import * as moment from 'moment'
import IndexService from '@/components/IndexService'
import axios from 'axios'
const pathheader = window.location.protocol
const bglist = ['#93c178', 'darksalmon', 'lightseagreen', 'khaki', 'lightsteelblue', 'mediumturquoise']

export default {
  name: 'headers',
  components: { Carousel, Slide, IndexService, HotelDatePicker },
  data () {
    return {
      initConfig: {},
      pathheader: pathheader,
      bglist: bglist,
      roomData: [],
      newsData: [],
      IGPopularData: [],
      GuestPopularData: [],
      book: {
        checkin: '',
        checkout: '',
        adults: 1,
        children: 0
      },
      ptBr: {
        night: '晚',
        nights: '晚',
        'day-names': ['日', '一', '二', '三', '四', '五', '六'],
        'check-in': '入住日',
        'check-out': '退房日',
        'month-names': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
      }
    }
  },
  methods: {
    getIGlink (igid) {
      return 'https://www.instagram.com/p/' + igid + '/'
    },
    shortText (edges) {
      var text = ''
      var t = ''
      if (edges.length > 0) {
        text = edges[0].node.text
        t = text.substr(0, 30)
        t += '...'
      } else {
        t = text
      }
      return t
    },
    captureText (text) {
      if (!text) {
        return ''
      }
      let t1 = text.split('Photo by')[1]
      if (!t1) {
        t1 = text.split('Photo share by')[1]
      }
      if (!t1) {
        t1 = text
      }
      let t2 = t1.indexOf(' on ')
      let t3 = t1.indexOf(' in ')
      var tt = ''
      if (t3 === -1 && t2 !== -1) {
        tt = t1.split(' on ')[0]
      } else if (t3 !== -1 && t2 === -1) {
        tt = t1.split(' in ')[0]
      } else if (t3 > t2) {
        tt = t1.split(' on ')[0]
      } else {
        tt = t1.split(' in ')[0]
      }
      return 'photo by ' + tt
    },
    getIGPopular () {
      axios.get('https://www.instagram.com/explore/tags/%E5%AF%8C%E6%9D%89%E6%99%B4/?__a=1')
      .then((response) => {
        // console.log(response)
        let res = response.data
        let data = (((res.graphql || {}).hashtag || {}).edge_hashtag_to_top_posts || {}).edges
        // let data = response.graphql.hashtag.edge_hashtag_to_top_posts
        // console.log(data)
        this.IGPopularData = data.map(d => d.node)
        // console.log(this.IGPopularData)
      })
      .catch((errorResponse) => {
        this.IGPopularData = []
      })
    },
    getGuestPopular () {
      axios.get(pathheader + '//rich-sunshine.tw/backend/api/WebMain/getGuestPhoto', {withCredentials: true})
      .then((response) => {
        // console.log(response)
        let res = response.data
        // let data = response.graphql.hashtag.edge_hashtag_to_top_posts
        // console.log(data)
        this.GuestPopularData = res
        // console.log(this.GuestPopularData)
      })
      .catch((errorResponse) => {
        this.GuestPopularData = []
      })
    },
    getRooms () {
      axios.get(pathheader + '//rich-sunshine.tw/backend/api/WebMain/getRooms', {withCredentials: true})
      .then((response) => {
        if (!response.data.success) {
          this.roomData = []
          return
        }
        const res = response.data
        this.roomData = res.data
      })
      .catch((errorResponse) => {
        this.roomData = []
      })
    },
    goNewsDetailPage (id) {
      this.$ga.event('news', 'click-one-news', 'news-' + id, 1)
      this.$router.push({name: 'NewsDetail', params: {id: id}})
    },
    getDate (fullDate) {
      var rule = /(\d{4})-(\d{2})-(\d{2})/
    //   var result = fullDate.exec(rule)
    //   console.log(result)
      return fullDate.replace(rule, '$3')
    },
    getMonth (fullDate) {
      var rule = /(\d{4})-(\d{2})-(\d{2})/
    //   var result = fullDate.match(rule)
      return fullDate.replace(rule, '$1, $2')
    },
    getInitConfig () {
      axios.get(pathheader + '//rich-sunshine.tw/backend/api/WebMain/getWebConfig', {withCredentials: true})
      .then((response) => {
        // console.log(response)
        const res = response.data
        res.data.forEach(dt => {
          console.log(dt)
          this.initConfig[dt.key] = dt.value
        })
      })
      .catch((errorResponse) => {
        // console.log(errorResponse)
      })
    },
    getNews () {
      axios.get(pathheader + '//rich-sunshine.tw/backend/api/WebMain/getNewsLimit', {withCredentials: true})
      .then((response) => {
        // console.log(response)
        const res = response.data
        this.newsData = res.data
      })
      .catch((errorResponse) => {
        // console.log(errorResponse)
      })
    },
    goContactPage () {
      this.$router.push('contact')
    },
    goRoomTypePage () {
      this.$router.push({name: 'Room'})
    },
    goRoomType (roomNameEng) {
      console.log(roomNameEng)
      let trimRoomNameEng = roomNameEng.split(' ').join('')
      console.log(trimRoomNameEng)
      this.$ga.event('room', 'click-one-room', 'room-' + trimRoomNameEng, 1)
      this.$router.push({name: 'RoomType', params: {id: trimRoomNameEng}})
    },
    goPetDetail () {
      let id = 'PET'
      this.$ga.event('news', 'click-to-PET', 'news-' + id, 1)
      this.$router.push({name: 'NewsDetail', params: {id: id}})
    },
    goBBQDetail () {
      let id = 'BBQ'
      this.$ga.event('news', 'click-to-BBQ', 'news-' + id, 1)
      this.$router.push({name: 'NewsDetail', params: {id: id}})
    },
    goSoleDetail () {
      let id = 'SOLE'
      this.$ga.event('news', 'click-to-SOLE', 'news-' + id, 1)
      this.$router.push({name: 'NewsDetail', params: {id: id}})
    },
    goPreknow () {
      this.$ga.event('know', 'click-know', 'preknow', 1)
      this.$router.push({name: 'Know'})
    },
    goRegulation () {
      this.$ga.event('know', 'click-know', 'regulation', 1)
      this.$router.push({name: 'Regulation'})
    },
    goQA () {
      this.$ga.event('know', 'click-know', 'QA', 1)
      this.$router.push({name: 'QA'})
    },
    goNews () {
      this.$ga.event('news', 'click-to-List', 'news-list', 1)
      this.$router.push({name: 'News'})
    },
    goAllRooms () {
      this.$ga.event('roomall', 'click-all-room', 'all', 1)
      this.$router.push({name: 'RoomTypeAll'})
    },
    getCheckinVal (val) {
      this.book.checkin = moment(val).format('DD-MM-YYYY')
    },
    getCheckoutVal (val) {
      this.book.checkout = moment(val).format('DD-MM-YYYY')
    },
    goBooking () {
      this.$ga.event('reserve', 'click-to-reserve', 'online', 1)
      var bookingUrl = 'https://book.revato.com/Grid?PropertyID=1917288&Source=LNK&AffiliateID=&BrandID=&IsHcDirect=False&currencycode=TWD&languagecode=TW&'
      console.log(moment(this.book.checkin, 'DD-MM-YYYY'))
      var params = 'CheckIn=' + moment(this.book.checkin, 'DD-MM-YYYY').format('YYYY-MM-DD') + '&CheckOut=' + moment(this.book.checkout, 'DD-MM-YYYY').format('YYYY-MM-DD') + '&label=1292735727'
      console.log(this.initConfig.booking_form_url)
      if (this.initConfig.booking_form_url === 1 || this.initConfig.booking_form_url === '1') {
        bookingUrl = 'https://app-apac.thebookingbutton.com/properties/richsunshineinndirect?locale=zh-TW&'
        params = 'check_in_date=' + this.book.checkin + '&check_out_date=' + this.book.checkout + '&number_adults=' + this.book.adults + '&number_children=' + this.book.children
      }
      window.open(bookingUrl + params)
    }
  },
  computed: {
    roomDataList () {
      let a = this.roomData.map((room) => {
        let roomImages = []
        room.roomNumbers.forEach((roomNumber) => {
          roomImages = roomImages.concat(roomNumber.images)
        })
        room.roomImages = roomImages
        room.main_img = roomImages[0]
        return room
      })
      return a
    },
    roomDataListFilterSorted () {
      return this.roomDataList.sort((a, b) => {
        if (parseInt(a.room_person) > parseInt(b.room_person)) {
          return 1
        }
        if (parseInt(a.room_person) < parseInt(b.room_person)) {
          return -1
        }
        return 0
      })
    },
    roomDataListFilterSortedBasic () {
      return this.roomDataList.filter((d) => {
        var did = parseInt(d.room_id)
        return (did !== 10 && did !== 11 && did !== 12 && did !== 13 && did !== 14) && d.room_suspend === '0'
      })
    },
    roomDataListFilterSortedSpec () {
      return this.roomDataList.filter((d) => {
        var did = parseInt(d.room_id)
        return (did === 10 || did === 11 || did === 12 || did === 13 || did === 14) && d.room_suspend === '0'
      })
    },
    current () {
      return this.$route.name || 'Hello'
    }
  },
  mounted () {
    this.getInitConfig()
    this.getRooms()
    this.getNews()
    // this.getGuestPopular()
  }
}
</script>

<style lang="scss" scoped>
#buildBDraw {
  flex-direction: row-reverse;
  @media screen and (max-width: 360px) {
    flex-direction: row;
  }
}
#buildADraw {
  margin-bottom: 50px;
}
.banner_content {
  background: linear-gradient(90deg, rgba(2,0,36,0) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,.4) 100%);
  border-radius: 10px;
  p {
    font-size: 16px;
    font-weight: 500;;
  }
}

.main_booking_area {
  margin-bottom: 150px;
  @media screen and (max-width: 992px) {
    margin-bottom: 0px;
  }
  .hotel_booking_area {
    bottom: -180px;
    .hotel_booking_table {
      flex-direction: row-reverse;
    }
    @media screen and (max-width: 992px) {
      bottom: 0px;
    }
    .book_table_title {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      h2 {
        text-align: right;
      }
    }
    .book_table_item {
      .book_table_option {
        flex: 1;
      }
      select {
        height: 48px;
        background: #fff;
        border: 1px solid #d7d9e2;
        cursor: pointer;
        color: #35343d;
        font-size: 14px;
        width: 100%;
      }
      label {
        height: 48px;
        line-height: 48px;
        color: #fff;
        padding: 0 10px;
        
        font-size: 14px;
      }
    }
  }
}


.ig-list {
  display: flex;
  flex-wrap: n0-wrap;
  background: black;
  padding: 20px 60px;
  position: relative;
  @media screen and (max-width: 1199px) {
    flex-wrap: wrap;
    .ig-item {
      width: 29%;
      margin: 2%;
      img {
        width: 100%;
      }
    }
  }
  .ig-item {
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
    }
    .shadow {
      position: absolute;
      top: 100%;
      transition: .6s ease-in-out;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.6);
      opacity: 0;
      color: #fff;
      padding: 5px;
      font-size: 10px;;
      span {
        position: absolute;
        bottom: 5px;
        right: 5px;
      }
    }
    &:hover .shadow {
      top: 0%;
      opacity: 1;
    }
  }
  &:before {
    position: absolute;
    content: "share your Travel with #富杉晴";
    top: -60px;
    left: 20%;
    font-size: 36px;
    border-bottom: 4px solid black;
    @media screen and (max-width: 1199px) {
      font-size: 18px;
    }
}
}
#bgVideo {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
}
.rooms-gallery {
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;
    padding: 60px 0;
    position: relative;
    margin: auto;
}
.section-title {
    margin: 40px 0;
    color: #231815;
    text-align: center;
    font-size: 36px;
    font-family: SerlioLTStd,serif;
    letter-spacing: 2px;
    line-height: 1;
    word-break: keep-all;
}
.drip-line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
    background: #ded7cf;
    width: 1px;
    height: 60px;
    margin: 0 auto;
    -webkit-transition: .5s;
    transition: .5s;
}
@media screen and (max-width: 1199px) {
  .rooms-gallery.-reverse {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
}

.rooms-gallery.-light {
    background: #f4f2ee;
}
.rooms-gallery.-reverse {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
}

@media screen and (max-width: 1199px) {
  .rooms-gallery {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    padding: 0 0 60px;
  }
}
.rooms-gallery, .rooms-gallery>.info {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: normal;
    background: transparent;
}
.rooms-gallery>.info {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 40%;
    padding: 60px 80px 0;
    z-index: 3;
}
@media screen and (max-width: 1199px) {
  .rooms-gallery.-reverse {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
}
@media screen and (max-width: 1199px) {
  .rooms-gallery>.info {
    width: 100%;
    padding: 0 20px 40px;
  }
}

.float_book_area {
  cursor: pointer;
  img {
    min-width: 300px;
    width: 30%;
    max-width: 500px;
  }
}

.float_book_area .button_button:before {
    content: "";
    background: rgba(84, 180, 180, 0.3);
    width: 25%;
    height: 76%;
    position: absolute;
    border-radius: 40px;
    transform: translateX(-50%);
    min-width: 250px;
    
    transition: .6s transform ease-out;
}
.float_book_area:hover .button_button:before {
  transform: translateX(-50%) translateY(20%) scale3d(1.8, 1.8, 1.8);
}

.float_book_area .button_button:after {
    content: "";
    background: rgba(84, 180, 180, .5);
    width: 100px;
    height: 100px;
    position: absolute;
    border-radius: 50%;
    transform: translateX(-40%) translateY(10px);
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue